import store from '../store';
import { isFunction } from 'lodash/fp';
import getOptionValue from 'src/store/preferences/getOptionValue';
export function appIsInDarkMode() {
    const isDarkMode = getOptionValue(2) === '2';
    return isDarkMode;
}
export function rowIsValid(row, rules, ctx) {
    if (!rules)
        return true;
    const errors = [];
    for (const rule of rules) {
        if (!rule.isValid(row))
            errors.push(rule.errorMessage);
    }
    if (errors.length > 0) {
        ctx.$q.notify({
            message: `<div class="text-h6">Row validation errors:</div><ul><li>${errors.join('</li><li>')}</li></ul>`,
            html: true
        });
        return false;
    }
    else {
        return true;
    }
}
export function vuexActionExists(actionName) {
    // @ts-ignore because "_actions" is not part of Store interface defition. but it exists. Know no other way to check if action exists
    return Object.keys(store._actions).includes(actionName);
}
export function showUnauthenticatedAndRedirect() {
    localStorage.notice = JSON.stringify({ message: `Access error. You are not authenticated.`, type: 'negative' });
    store.dispatch('authorizedUser/doLogout');
}
// https://stackoverflow.com/a/55533058/6565721
// Here is a generic solution for summing N arrays as vectors, of possibly different lengths
export function sumArrays(arrays) {
    const n = arrays.reduce((max, xs) => Math.max(max, xs.length), 0);
    const result = Array.from({ length: n });
    return result.map((_, i) => arrays.map(xs => xs[i] || 0).reduce((sum, x) => sum + x, 0));
}
/** if `maybeFn` is function, it is invoked with `args`. Else `false` is returned */
export const invokeOrFalse = (maybeFn, ...args) => isFunction(maybeFn) ? maybeFn(...args) : false;
/** if `maybeFn` is function, it is invoked with optional `args`. Else undefined is returned */
export const invokeOrUndefined = (maybeFn, ...args) => isFunction(maybeFn) ? maybeFn(...args) : undefined;
export const invokeOrVoid = (maybeFn, ...args) => isFunction(maybeFn) ? maybeFn(...args) : undefined;
/** if `maybeFn` is function, it is invoked with `args`.  Else it is returned as identity */
export const invokeOrIdentity = (maybeFn, ...args) => {
    if (isFunction(maybeFn)) {
        return maybeFn(...args);
    }
    else {
        return maybeFn;
    }
};
/**
 * if `fn` is function, it is invoked with `args`. Else `args[0]` is returned
 */
export const invokeOrArgument = (fn, ...args) => {
    return isFunction(fn) ? fn(...args) : args[0];
};
export const applyFunctionOrReturnArgument = (fn, something) => {
    return isFunction(fn) ? fn(something) : something;
};
